import ArrowRightSmall from './images/icon-arrow-right-small.svg';

export default function TransactionsBox() {
  return (
    <>
      <div className="transition-transactions-financial-statement transactions">
        <h4>Transactions</h4>
        <p>The company borrowed $100,000 loan from the bank</p>
      </div>
      <img src={ArrowRightSmall} alt="Arrow right" className="arrow-right-small"/>
    </>
  );
}